import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonLabel, IonLoading, IonRow, IonTitle, IonToast } from '@ionic/react';
import { arrowBack, trashOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { alterarStatusProjeto, requestService, urlBaseCore } from '../../../../../Utils/Services';
import iconMercadopago from '../ComandasFechar/imgs/mercadopagoIcon.svg';

type Props = {
  projetoid: string;
  dadosComandas: any;
  onClose: () => void;
  onConfirm: (novaComanda: any) => void;
};

const AlterarPagamentoModal: React.FC<Props> = ({ projetoid, dadosComandas, onClose, onConfirm }) => {
  const history = useHistory<any>();
  const { dadosEmpresa } = useContext(MessageContext);

  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState('');

  const [arrayFormaPagamento, setArrayFormaPagamento] = useState<any[]>([]);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<string>('0,00');
  const [valorTotal, setValorTotal] = useState<string>('0,00');
  const [desconto, setDesconto] = useState<string>('');
  const [taxaServico, setTaxaServico] = useState<string>('');
  const [taxaEntrega, setTaxaEntrega] = useState<string>('');
  const [divididoPor, setDivididoPor] = useState<any>('');

  const buscarInputRef = useRef<any>(null);

  // Carregar dados frescos da API ao abrir o modal
  useEffect(() => {
    carregarDados();
  }, []);

  // Recalcular total quando taxas mudam
  useEffect(() => {
    try {
      const tsFloat = parseFloat((taxaServico || '0').replace(/\./g, '').replace(',', '.')) || 0;
      const dFloat = parseFloat((desconto || '0').replace(/\./g, '').replace(',', '.')) || 0;
      const teFloat = parseFloat((taxaEntrega || '0').replace(/\./g, '').replace(',', '.')) || 0;
      let total = parseFloat((valorTotalProdutos || '0').replace(/\./g, '').replace(',', '.')) || 0;
      total += teFloat;
      total -= dFloat;
      total += total * (tsFloat / 100);
      setValorTotal(total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    } catch { }
  }, [taxaServico, desconto, taxaEntrega, valorTotalProdutos]);

  function carregarDados() {
    const consultar = async () => {
      const token = localStorage.getItem('token') || '';
      setShowLoading(true);
      try {
        const resp = await fetch(urlBaseCore.url + '/ordens/' + projetoid.replaceAll(/#/g, '%23'), {
          method: urlBaseCore.method,
          headers: [['token', token]] as any,
          credentials: 'include',
        });
        const response = await resp.json();
        if (response.Item) {
          setArrayFormaPagamento(Array.isArray(response.Item.formaPagamento) ? [...response.Item.formaPagamento] : []);
          setDesconto(response.Item.desconto || '');
          setTaxaServico(response.Item.taxaServico || '');
          setTaxaEntrega(response.Item.taxaEntrega || '');
          setValorTotalProdutos(
            response.Item.valorTotalProdutos
              ? String(response.Item.valorTotalProdutos).includes(',')
                ? response.Item.valorTotalProdutos
                : Number(response.Item.valorTotalProdutos).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : '0,00'
          );
          if (response.Item.valorTotal) {
            setValorTotal(
              String(response.Item.valorTotal).includes(',')
                ? response.Item.valorTotal
                : Number(response.Item.valorTotal).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            );
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        setShowLoading(false);
      }
    };
    consultar();
  }

  const somaValores = () =>
    arrayFormaPagamento.reduce((total: number, campo: any) => {
      return total + (parseFloat((campo.valor || '0').replace(/\./g, '').replace(',', '.')) || 0);
    }, 0);

  const calcularRestante = () => {
    const totalNum = parseFloat((valorTotal || '0').replace(/\./g, '').replace(',', '.')) || 0;
    return Math.max(0, totalNum - somaValores());
  };

  const calcularTroco = () => {
    const totalNum = parseFloat((valorTotal || '0').replace(/\./g, '').replace(',', '.')) || 0;
    const soma = somaValores();
    return soma > totalNum ? soma - totalNum : 0;
  };

  const calcularDivisao = () => {
    const n = parseFloat((divididoPor || '0').replace(/\D/g, '')) || 0;
    if (n <= 0) return '∞';
    const totalNum = parseFloat((valorTotal || '0').replace(/\./g, '').replace(',', '.')) || 0;
    return (totalNum / n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' pra cada';
  };

  const handleAdicionarFormaPagamento = (opcao: any) => {
    const restante = calcularRestante();
    if (restante <= 0) return;
    const novo = {
      id: crypto.randomUUID(),
      pagamento: opcao?.nome || opcao,
      tipo: opcao?.tipo || '',
      valor: restante.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    };
    const atualizada = [...arrayFormaPagamento, novo];
    setArrayFormaPagamento(atualizada);
    persistir(atualizada);
  };

  const handleRemoverFormaPagamento = (index: number) => {
    const atualizada = arrayFormaPagamento.filter((_: any, i: number) => i !== index);
    setArrayFormaPagamento(atualizada);
    persistir(atualizada);
  };

  const onChangeValor = (e: any, index: number) => {
    e.preventDefault();
    let v = e.target.value;
    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, '$1,$2');
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    const novos = [...arrayFormaPagamento];
    novos[index].valor = v;
    setArrayFormaPagamento(novos);
  };

  const salvarValor = () => {
    persistir(arrayFormaPagamento);
  };

  function persistir(formas: any[]) {
    return new Promise((resolve, reject) => {
      const obj = {
        formaPagamento: formas,
        troco: calcularTroco().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        taxaEntrega,
        taxaServico,
        desconto,
      };
      requestService(
        alterarStatusProjeto.url.replaceAll('{id}', projetoid.replaceAll(/#/g, '%23')) + '?alteracao=true',
        {
          method: alterarStatusProjeto.method,
          headers: [['token', localStorage.getItem('token') || '']] as any,
          credentials: 'include',
          body: JSON.stringify(obj),
        },
        history,
        (response: any) => resolve(response),
        (error: any) => {
          setTextToast(error.message);
          setShowToast(true);
          reject(error);
        }
      );
    });
  }

  async function handleSalvar() {
    setShowLoading(true);
    try {
      const result = await persistir(arrayFormaPagamento);
      onConfirm(result);
    } catch (e: any) {
      setTextToast(e?.message || 'Erro ao salvar pagamento.');
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }

  return (
    <>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={onClose} />
          </IonButtons>
          <IonTitle>Alterar Pagamento</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>
        <IonLoading isOpen={showLoading} message="Aguarde..." />

        <IonGrid>
          {/* Formas de pagamento disponíveis */}
          <IonRow>
            <IonCol size="12">
              <IonLabel>Forma de pagamento:</IonLabel>
            </IonCol>
          </IonRow>
          <IonRow>
            {dadosEmpresa?.formaPagamento?.map((item: any, index: number) => {
              if (!item.exibirPdv) return null;
              return (
                <IonCol size="auto" key={index}>
                  <IonButton
                    style={{ height: '30px', fontSize: '12px', margin: '0px' }}
                    expand="block"
                    shape="round"
                    onClick={() => handleAdicionarFormaPagamento(item)}
                  >
                    {(item.tipo || '').startsWith('Mercado Pago') && (
                      <IonIcon icon={iconMercadopago} style={{ fontSize: '20px', marginRight: '4px' }} />
                    )}
                    {item.nome.toUpperCase()}
                  </IonButton>
                </IonCol>
              );
            })}
          </IonRow>
        </IonGrid>

        <IonToast isOpen={showToast} position="middle" onDidDismiss={() => setShowToast(false)} message={textToast} duration={3000} />
      </IonContent>

      <IonFooter>
        <IonToolbar>
          <IonGrid>

            {/* Lista de pagamentos adicionados */}
            <IonRow style={{ borderBottom: '1px solid #e0e0e0' }}>
              <IonCol size="12" style={{ padding: 0, margin: 0 }}>
                <IonGrid style={{ padding: 0, margin: 0 }}>
                  {arrayFormaPagamento.map((campo: any, index: number) => (
                    <div key={index} style={{ marginBottom: '6px' }}>
                      <IonRow className="ion-align-items-center">
                        <IonCol size="4" style={{ display: 'flex', alignItems: 'center', padding: '0 4px' }}>
                          <IonLabel style={{ fontSize: '14px', fontWeight: 'bold' }}>{campo.pagamento}:</IonLabel>
                        </IonCol>
                        <IonCol size="4" style={{ padding: '0 4px' }}>
                          <IonInput
                            disabled={campo.pagou}
                            clearInput
                            style={{ '--background': '#f5f5f5', height: '35px', borderRadius: '20px', border: '1px solid #ccc', fontSize: '14px' }}
                            type="tel"
                            maxlength={14}
                            placeholder="Valor"
                            value={campo.valor || ''}
                            onIonChange={(e: any) => onChangeValor(e, index)}
                            onIonBlur={salvarValor}
                          />
                        </IonCol>
                        <IonCol size="3" style={{ padding: '0 4px' }} />
                        <IonCol size="1" style={{ textAlign: 'right', padding: '0 4px' }}>
                          <IonIcon
                            icon={trashOutline}
                            style={{ cursor: campo.pagou ? 'not-allowed' : 'pointer', color: campo.pagou ? 'gray' : 'red', fontSize: '20px' }}
                            onClick={() => { if (!campo.pagou) handleRemoverFormaPagamento(index); }}
                          />
                        </IonCol>
                      </IonRow>
                    </div>
                  ))}
                </IonGrid>
              </IonCol>
            </IonRow>

            {/* Restante e Troco */}
            <IonRow>
              <IonCol size="6"><IonLabel>Restante:</IonLabel></IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>R$ {calcularRestante().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonLabel>
              </IonCol>
            </IonRow>
            <IonRow style={{ borderBottom: '1px solid #e0e0e0' }}>
              <IonCol size="6"><IonLabel>Troco:</IonLabel></IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}>
                <IonLabel>R$ {calcularTroco().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</IonLabel>
              </IonCol>
            </IonRow>

            {/* Totais */}
            <IonRow>
              <IonCol size="6" style={{ fontWeight: 'bold' }}><IonLabel>Subtotal:</IonLabel></IonCol>
              <IonCol size="6" style={{ textAlign: 'right', fontWeight: 'bold' }}><IonLabel>R$ {valorTotalProdutos}</IonLabel></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6"><IonLabel>Desconto:</IonLabel></IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}><IonLabel>R$ {desconto || '0,00'}</IonLabel></IonCol>
            </IonRow>
            <IonRow style={{ borderBottom: '1px solid #e0e0e0' }}>
              <IonCol size="6"><IonLabel>Taxa de Serviço:</IonLabel></IonCol>
              <IonCol size="6" style={{ textAlign: 'right' }}><IonLabel>{taxaServico || '0'}%</IonLabel></IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6" style={{ fontWeight: 'bold', fontSize: '18px' }}><IonLabel>Total:</IonLabel></IonCol>
              <IonCol size="6" style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '18px' }}><IonLabel>R$ {valorTotal}</IonLabel></IonCol>
            </IonRow>

            {/* Botões */}
            <IonRow>
              <IonCol>
                <IonButton expand="block" style={{ height: '46px', fontSize: '18px' }} onClick={handleSalvar}>
                  Salvar
                </IonButton>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <IonButton expand="block" fill="outline" color="medium" style={{ height: '46px', fontSize: '18px' }} onClick={onClose}>
                  Cancelar
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

export default AlterarPagamentoModal;
